<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" size="small" @click="add">新建方案</el-button>
      </div>
      <div>
        <el-input
          clearable
          v-model.trim="searchCondition.planName"
          placeholder="请输入方案名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-date-picker
          clearable
          :default-time="['00:00:00', '23:59:59']"
          v-model="searchCondition.createTimeArry"
          type="datetimerange"
          align="right"
          start-placeholder="请选择开始时间筛选"
          end-placeholder="请选择结束时间筛选"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
        ></el-date-picker>
        <el-select
          clearable
          v-model="searchCondition.planStatus"
          placeholder="奖励状态"
          size="small"
          filterable
          class="mr10"
        >
          <el-option label="上线" value="open"></el-option>
          <el-option label="下线" value="close"></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button type="info" size="small" @click="reset">重置</el-button>
        <el-button
          type="success"
          size="small"
          @click="output('queryAllList', '奖励方案')"
          :loading="isOutputing"
          >导出方案信息</el-button
        >
      </div>
    </div>
    <div class="flex flex-start mt20 mb10">
      <el-radio-group
        v-model="searchCondition.timeState"
        size="small"
        @change="switchTab"
      >
        <el-radio-button label="going">进行中</el-radio-button>
        <el-radio-button label="notStart">未开始</el-radio-button>
        <el-radio-button label="end"> 已过期</el-radio-button>
        <el-radio-button label="all">全部</el-radio-button>
      </el-radio-group>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="planName"
          label="方案名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="rewardType"
          label="奖励类型"
        >
          <template slot-scope="scope">
            {{
              scope.row.rewardType === "fixed"
                ? "按数量固定奖励"
                : "按金额百分比奖励"
            }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopName"
          label="奖励范围"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="rewardValue"
          label="奖励值"
        >
          <template slot-scope="scope">
            {{ scope.row.rewardValue
            }}{{ scope.row.rewardType === "fixed" ? "元" : "%" }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="startTime"
          label="开始时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="endTime"
          label="结束时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="endTime"
          label="效期状态"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.timeState === 'going'" class="success">
              进行中
            </div>
            <div v-if="scope.row.timeState === 'notStart'" class="gray">
              未开始
            </div>
            <div v-if="scope.row.timeState === 'end'" class="danger">
              已结束
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="planStatus"
          label="奖励状态"
        >
          <template slot-scope="scope">
            <div
              :class="scope.row.planStatus === 'open' ? 'success' : 'danger'"
            >
              {{ scope.row.planStatus === "open" ? "上线" : "下线" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作"
          width="200"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button size="small" type="text" @click="edit(scope.row)"
                >编辑</el-button
              >
              <el-button size="small" type="text" @click="toDetails(scope.row)"
                >查看</el-button
              >
              <el-button
                :class="scope.row.planStatus === 'open' ? 'danger' : 'success'"
                size="small"
                type="text"
                @click="upDate(scope.row)"
                >{{
                  scope.row.planStatus === "open" ? "下线" : "上线"
                }}</el-button
              >
              <el-button size="small" type="text" @click="copy(scope.row)"
                >复制</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      isOutputing: false,
      searchCondition: {
        timeState: "going"
      },
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    reset() {
      this.searchCondition = {
        timeState: this.searchCondition.timeState
      };
    },
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.timeState =
        searchCondition.timeState === "all" ? "" : searchCondition.timeState;
      searchCondition.startTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[0]
          : null;
      searchCondition.endTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[1]
          : null;
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch("rewardPlanList", params);
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    async queryAllList() {
      let params = {
        pageNo: 1,
        pageSize: 999999
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.timeState =
        searchCondition.timeState === "all" ? "" : searchCondition.timeState;
      searchCondition.startTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[0]
          : null;
      searchCondition.endTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[1]
          : null;
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryPlanExportList",
        params
      );
      return result;
    },
    toDetails(row) {
      this.$router.push({
        name: "DetailsRewardProgram",
        query: {
          planId: row.planId
        }
      });
    },
    async upDate(row) {
      let params = JSON.parse(JSON.stringify(row));
      params.planStatus = params.planStatus === "open" ? "close" : "open";
      const { code } = await this.$store.dispatch("editRewardPlan", params);
      if (code === "0") {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.queryList();
      }
    },
    copy(row) {
      this.$router.push({
        name: "AddRewardProgram",
        query: {
          type: "copy",
          planId: row.planId
        }
      });
    },
    edit(row) {
      this.$router.push({
        name: "AddRewardProgram",
        query: {
          type: "edit",
          planId: row.planId
        }
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    // 导出excel
    output(funcName, title) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        const func = this[funcName];
        func()
          .then(res => {
            const list = res;
            list.forEach(v => {
              v.rewardType =
                v.rewardType === "fixed"
                  ? "按数量固定奖励"
                  : "按金额百分比奖励";

              v.rewardValue =
                v.rewardType === "按数量固定奖励"
                  ? v.rewardValue + "元"
                  : v.rewardValue + "%";

              v.planStatus = v.planStatus === "open" ? "上线" : "下线";

              if (v.timeState === "going") {
                v.timeState = "进行中";
              } else if (v.timeState === "notStart") {
                v.timeState = "未开始";
              } else if (v.timeState === "end") {
                v.timeState = "已结束";
              }

              if (v.bindingType === "goods") {
                v.bindingType = "关联商品";
              } else if (v.bindingType === "category") {
                v.bindingType = "关联品类";
              } else if (v.bindingType === "brand") {
                v.bindingType = "关联品牌";
              }
            });
            // const tHeader = this.$refs.table.columns
            //   .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
            //   .filter(o => o);
            const tHeader = [
              "方案id",
              "方案名称",
              "门店范围",
              "有效期状态",
              "方案状态",
              "奖励类型",
              "奖励值",
              "开始时间",
              "结束时间",
              "商品设置时间",
              "关联类别",
              "分类编码",
              "分类名称",
              "品牌编码",
              "品牌名称",
              "商品编码",
              "商品名称",
              "商品零售价"
            ];
            let filterVal = [
              "planCode",
              "planName",
              "shopName",
              "timeState",
              "planStatus",
              "rewardType",
              "rewardValue",
              "startTime",
              "endTime",
              "createTime",
              "bindingType",
              "categoryId",
              "categoryName",
              "brandName",
              "brandId",
              "goodsSn",
              "spuName",
              "recommendedRetailPrice"
            ];
            // if (list.length > 0) {
            //   filterVal = this.$refs.table.$children
            //     .map(o => o._props.prop)
            //     .filter(o => o);
            // }

            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    add() {
      this.$router.push({
        name: "AddRewardProgram"
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    switchTab() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped></style>
